import * as React from "react";

export const AwaitComponent = ({ children }) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const checkLoaded = () => {
      if (window) {
        setLoaded(true);
      } else {
        setTimeout(checkLoaded, 100);
      }
    };

    checkLoaded();
  }, []);

  if (loaded) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return <React.Fragment />;
  }
};

//check is ios
const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

const useAutosizeTextArea = (
  textAreaRef,
  value,
  minHeight = 0,
  active = true,
  trigger,
  trigger2
) => {
  const [render, setRender] = React.useState(0);

  // const

  // console.log("C :", {
  //   textAreaRef,
  //   value,
  //   minHeight,
  //   active,
  //   trigger,
  //   trigger2,
  // });

  React.useEffect(() => {
    if (active) {
      setTimeout(() => {
        if (!textAreaRef) {
          setRender(render + 1);
        }
      }, 50);
    }
  }, [textAreaRef, render]);

  React.useEffect(() => {
    if (textAreaRef && active) {
      textAreaRef.style.height = "0px";
      const scrollHeight = isIos()
        ? textAreaRef.scrollHeight + 15
        : textAreaRef.scrollHeight;

      textAreaRef.style.height = scrollHeight + "px";
      // textAreaRef.style.minHeight = minHeight > 0 ? `${minHeight}px` : "64px";
    }
  }, [textAreaRef, value, render, trigger, trigger2, minHeight]);
};

export default useAutosizeTextArea;
